import { COMPANY } from "@/lib/company";

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="max-w-4xl mx-auto px-6 lg:px-8 py-20 lg:py-28 text-slate-300">
      <span className="text-red-500 font-display text-xs tracking-[0.3em] font-bold">LEGAL</span>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-white tracking-tighter mt-3">
        Privacy Policy
      </h1>
      <p className="text-slate-500 text-sm mt-3">Last updated: {new Date().toLocaleDateString()}</p>

      <div className="prose prose-invert mt-10 space-y-6 leading-relaxed">
        <p>
          {COMPANY.name} respects your privacy. This policy describes what we collect, why we collect it, and how we keep it safe.
        </p>
        <h2 className="font-display text-2xl font-bold text-white mt-8">Information We Collect</h2>
        <p>
          We collect the information you voluntarily provide on our contact form (name, company, sourcing needs, email, phone, optional invoice attachment) to respond to sourcing requests.
        </p>
        <h2 className="font-display text-2xl font-bold text-white mt-8">How We Use It</h2>
        <p>
          Submissions are used solely to deliver a sourcing quote and operate your portal engagement. We do not sell your data. We do not share it with third parties except as needed to fulfil a sourcing request you have explicitly authorised.
        </p>
        <h2 className="font-display text-2xl font-bold text-white mt-8">Payment Processing</h2>
        <p>
          Card payments are handled by Stripe under their own privacy and PCI-DSS controls. We never see or store full payment card data on our servers.
        </p>
        <h2 className="font-display text-2xl font-bold text-white mt-8">Contact</h2>
        <p>
          To exercise any privacy right or request data deletion, email <a href={COMPANY.emailLink} className="text-red-500 hover:underline">{COMPANY.email}</a>.
        </p>
      </div>
    </div>
  );
}
